import { Component } from '@angular/core'
import { setCommandsMetrics } from '@helios/state-management'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'

@Component({
  selector: 'hs-transaction-delete-note-modal',
  templateUrl: './transaction-delete-note-modal.component.html',
  styleUrls: [],
})
export class TransactionDeleteNoteModalComponent {
  constructor(
    public activeModal: NgbActiveModal,
    private readonly store: Store,
  ) {}
  delete() {
    this.store.dispatch(
      setCommandsMetrics({
        command: 'deleteNote',
        time: Date.now(),
      }),
    )
    this.activeModal.close()
  }
}
